import { render } from "./filtrosEstoqueComponent.vue?vue&type=template&id=534412f6&scoped=true"
import script from "./filtrosEstoqueComponent.vue?vue&type=script&lang=js"
export * from "./filtrosEstoqueComponent.vue?vue&type=script&lang=js"

import "./filtrosEstoqueComponent.vue?vue&type=style&index=0&id=534412f6&scoped=true&lang=css"
import "./filtrosEstoqueComponent.vue?vue&type=style&index=1&id=534412f6&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534412f6"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QInput,QField});
